<template>
  <div class="dashboard-grid">
    <div
      v-for="(chart, index) in charts"
      :key="index"
      class="dashboard-grid-item"
    >
      <ChartCard
        v-if="chart"
        :chart-title="chart.title"
        :chart-data="chart"
        :chart-index="index"
        :is-selected="selectedChartIndex === index"
        @chart-selected="handleChartSelected"
      />
      <div v-else class="empty-chart-slot" @click="handleEmptySlotClick" :title="'Click to open chat and create a new plot'">
        <p class="empty-slot-text">Add/create a new plot here from the chat.</p>
      </div>
    </div>
  </div>
</template>

<script>
import ChartCard from "./ChartCard.vue";

export default {
  name: "DashboardGrid",
  components: {
    ChartCard,
  },
  props: {
    charts: {
      type: Array,
      required: true,
      default: () => [],
    },
    selectedChartIndex: {
      type: Number,
      default: null,
    },
  },
  methods: {
    handleEmptySlotClick() {
      this.$emit("empty-slot-click");
    },
    handleChartSelected(index) {
      this.$emit("chart-selected", index);
    },
  },
};
</script>

<style scoped>
@import '../../assets/Styling/agenticDashboard/dashboardGrid.css';
</style>

